import React from 'react';
import Carte from '../ui/Carte';
import ChampTexte from '../champs/ChampTexte';

function SectionDevisSpecifique({ donnees, onChange }) {
  return (
    <Carte titre="Informations spécifiques au devis" icone="🧾">
      <div className="grille grille--2col">
        <ChampTexte
          label="Date de validité du devis"
          valeur={donnees.dateValidite}
          onChange={(_, val) => onChange('dateValidite', val)}
          nom="dateValidite"
          type="date"
        />
        <ChampTexte
          label="Nombre d'intervenants"
          valeur={donnees.nombreIntervenants}
          onChange={(_, val) => onChange('nombreIntervenants', val)}
          nom="nombreIntervenants"
          placeholder="3"
        />
      </div>
    </Carte>
  );
}

export default SectionDevisSpecifique;
